import { Button } from '@petsmart-ui/sparky';

import type { MenuQuickLink, PrimaryNavigationItem } from '../../../types';
import { Drawer } from './drawer';
import { useMobileMenu } from './use-mobile-menu';

import './mobile-menu.scss';

type MobileMenuProps = {
    items: PrimaryNavigationItem[];
    quickLinks: MenuQuickLink[];
};

export function MobileMenu({ items, quickLinks }: MobileMenuProps) {
    const { closeMenu, handleOpenChangeComplete, isOpen, openMenu, setIsOpen, triggerRef } = useMobileMenu();

    return (
        <>
            <Button
                buttonRef={triggerRef}
                aria-expanded={isOpen}
                aria-label="Open menu"
                iconSize="lg"
                iconName="menu"
                variant="bare"
                className="mobile-menu"
                onClick={openMenu}
            />
            <Drawer
                isOpen={isOpen}
                items={items}
                onCloseAll={closeMenu}
                onOpenChange={setIsOpen}
                onOpenChangeComplete={handleOpenChangeComplete}
                quickLinks={quickLinks}
            />
        </>
    );
}
